import type { CSSProperties, ReactNode } from 'react';

type StripeColor = 'ink' | 'red' | null;

interface AccentCardProps {
  children: ReactNode;
  /** Left accent stripe color. ink = neutral / Scenario A. red = signal / Scenario B / break-even. null = no stripe. */
  stripe?: StripeColor;
  /** Card padding shorthand. Defaults to "20px 24px". */
  padding?: string;
  className?: string;
  style?: CSSProperties;
}

const STRIPE_COLOR: Record<NonNullable<StripeColor>, string> = {
  ink: 'var(--tco-ink)',
  red: 'var(--tco-neg)',
};

/**
 * Phase 25 — white surface card with optional 3px left accent stripe.
 *
 * Used for the headline TCO delta (ink stripe), Scenario A selector
 * (ink stripe), Scenario B selector (red stripe), break-even card
 * (red stripe), and any plain panel (no stripe).
 */
export default function AccentCard({
  children,
  stripe = null,
  padding = '20px 24px',
  className,
  style,
}: AccentCardProps) {
  const borderLeft = stripe ? `3px solid ${STRIPE_COLOR[stripe]}` : undefined;
  return (
    <div
      className={className}
      style={{
        background: 'var(--tco-surface)',
        border: '1px solid var(--tco-line)',
        borderLeft,
        borderRadius: 'var(--tco-radius)',
        padding,
        ...style,
      }}
    >
      {children}
    </div>
  );
}
